import * as React from 'react';
import { useLocation } from 'wouter';
import { URL_ECO_DRIVE, URL_TRIPS_OVERVIEW } from '../../../router/constants';
import useAnalytics from '../../../hooks/useAnalytics';

interface IEcoDriveProps {
  value: string;
  rideId: string;
  vehicleId: number;
  isAdditional?: boolean;
  datacyIndex: number;
}
function EcoDrive(props: IEcoDriveProps) {
  const [, navigate] = useLocation();
  const { trackEvent } = useAnalytics();

  const openEcoDriveSubpage = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    navigate(
      props.rideId
        ? `${URL_TRIPS_OVERVIEW}${URL_ECO_DRIVE}/${props.vehicleId}/${props.rideId}`
        : URL_TRIPS_OVERVIEW
    );
    trackEvent(['ride book', 'click', 'Ride book open eco drive in new tab']);
  };

  const getElement = () => {
    let element = <div />;
    if (Number(props.value.replace(',', '.')) < 5) {
      element = (
        <a
          data-cy={`row-${props.datacyIndex + 1}-ecodrive`}
          title=""
          href=""
          className="b-eco-drive-info bad"
          onClick={openEcoDriveSubpage}
        >
          <i className="cmd-icon cmd-icon-eco-drive-bad" />
          {props.value}
        </a>
      );
    } else if (Number(props.value.replace(',', '.')) < 8) {
      element = (
        <a
          data-cy={`row-${props.datacyIndex + 1}-ecodrive`}
          title=""
          href=""
          className="b-eco-drive-info not-good"
          onClick={openEcoDriveSubpage}
        >
          <i className="cmd-icon cmd-icon-eco-drive-not-good" />
          {props.value}
        </a>
      );
    } else {
      element = (
        <a
          data-cy={`row-${props.datacyIndex + 1}-ecodrive`}
          title=""
          href=""
          className="b-eco-drive-info good"
          onClick={openEcoDriveSubpage}
        >
          <i className="cmd-icon cmd-icon-eco-drive-good" />
          {props.value}
        </a>
      );
    }
    return element;
  };

  return props.isAdditional ? (
    getElement()
  ) : (
    <div
      className="align-middle text-right justify-content-end"
      style={{
        minWidth: '88px',
        maxWidth: '88px',
        flex: 1,
      }}
    >
      {getElement()}
    </div>
  );
}

export default EcoDrive;
